

<script>
  import { onMount, onDestroy } from "svelte";
 

  import Swiper from 'swiper';
  import { Autoplay, Navigation, Pagination } from "swiper/modules";

  /// import EffectCarousel from "./carousel/effect-carousel.min.modified.js";
  import EffectCarousel from "./carousel/effect-carousel.modified.js";

  import "swiper/css";
  import "swiper/css/navigation";
  import "swiper/css/pagination";
  import "./carousel/effect-carousel.min.css";
  import "./carousel/main.css";


  export let slides = []; // <–– tar emot arrayen från App.svelte

  export let maxWidthSelected = "";
  export let frameCss = "1px solid #fff";

  export let sideSlides = "1";
  export let autoPlay = false;
  export let sideSlideOpacity = "0.33";
  export let showPaggan = true;
  export let startSlide = 1;
  export let borderRadius = 0;
  export let backdropFilter = 0;
  export let transModifier = "{ 1: 70, 2: 50, 3: 67 }";
  export let scaleStep = "0.2";



  let swiper;

  let container;

  onMount(() => {

    // console.log(sideSlides );

    // console.log(scaleStep);

  
  let firstImageRatio = 16/9; // fallback
  const img = container.querySelector("img");

    if (img?.naturalWidth && img?.naturalHeight) {
      firstImageRatio = img.naturalWidth / img.naturalHeight;
      container.style.setProperty("--aspect", firstImageRatio);
    } else {
      img?.addEventListener("load", () => {
        const r = img.naturalWidth / img.naturalHeight;
        container.style.setProperty("--aspect", r);
      });
    }








swiper = new Swiper('.swiper', {

        modules: [Autoplay, Navigation, Pagination, EffectCarousel],
        effect: 'carousel',
        carouselEffect: {
            opacityStep: parseFloat(sideSlideOpacity),
            scaleStep: parseFloat(scaleStep),
            sideSlides: parseInt(sideSlides),
            transModifier: normalizeTransModifier(transModifier),
            debug: false   // 👈 aktiverar loggar i konsolen
        },
        grabCursor: true,
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: 'auto',
        autoHeight: true,
        initialSlide: startSlide - 1 ,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: showPaggan ? { el: '.swiper-pagination' } : false, 
        autoplay: autoPlay ? { delay: 3000 } : false, 
});




  });

  onDestroy(() => {
  if (swiper) swiper.destroy(true, false);
});


function hexToRgba(hex, opacity = 1) {
  // Ta bort eventuell "#" i början
  hex = hex.replace(/^#/, '');

  // Hantera korta hex-koder (#fff)
  if (hex.length === 3) {
    hex = hex.split('').map(x => x + x).join('');
  }

  // Omvandla till numeriska värden
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

  function withUnit(value) {
    // Om värdet är null, undefined eller tomt, returnera tomt
    if (!value) return '';

    // Om det redan slutar med giltig CSS-enhet → returnera som det är
    if (typeof value === 'string' && /[a-z%]+$/i.test(value.trim())) {
      return value;
    }

    // Om det är ett rent tal → lägg till "rem"
    return `${value}rem`;
  }
 


 function normalizeTransModifier(input, debug = false) {
  // Om det redan är ett objekt, returnera direkt
  if (typeof input === "object" && input !== null) {
    if (debug) console.log("normalizeTransModifier: objekt redan OK ✅");
    return input;
  }

  // Om det är en sträng
  if (typeof input === "string") {
    try {
      const clean = input
        .trim()
        .replace(/;$/, "")              // ta bort ev. avslutande semikolon
        .replace(/(\d+)\s*:/g, '"$1":') // gör giltig JSON
        .replace(/'/g, '"');            // enkel→dubbelcitat, för säkerhets skull

      const parsed = JSON.parse(clean);
      if (debug) console.log("normalizeTransModifier: sträng konverterad ✅", parsed);
      return parsed;
    } catch (err) {
      console.warn("normalizeTransModifier: kunde inte tolka strängen ❌", err);
    }
  }

  // Fallback
  if (debug) console.log("normalizeTransModifier: fallback till standardvärden ⚙️");
  return { 1: 70, 2: 50, 3: 67 };
}


</script>

<style global type="text/scss" lang="scss">

  :root {
    
    --gr-theme-color: #ffffff;

    --ds-font--sans: "DNSansVF";
    --ds-font--serif: "DNSerifVF";


  }  




a,
a:link,
a:visited,
a:hover {
  color: var(--gr-theme-color);
  text-decoration: none;
}



.swiper-carousel {
  width: 100%;
  max-width: unset;
}

.swiper-carousel .swiper-slide {
  width: 100%;
  height: auto;
  background: transparent;
  max-width: 50%;
  overflow:hidden;
}

.swiper-carousel .swiper-slide .picLink {
  pointer-events: none; /* 👈 förhindrar klick */
  cursor: default;      /* ändrar muspekaren */
}

.swiper-carousel .swiper-slide.swiper-slide-active .picLink {
  pointer-events: auto ; /* 👈 förhindrar klick */
  cursor: pointer;      /* ändrar muspekaren */
}


.swiper-carousel .swiper-slide.swiper-slide-active .picLink.noLink {
  pointer-events: none; /* 👈 förhindrar klick */
  cursor: default;      /* ändrar muspekaren */
}


.swiper-carousel-border-background {

    position: relative;
    width: 100%;
    background-color: #111;
    overflow:hidden;
    box-sizing: border-box;
    mask-image: radial-gradient(#fff, #fff);
    -webkit-mask-image: radial-gradient(#fff, #fff);
    transform: translateZ(0);

}

.swiper-carousel-animate-opacity {
    position: relative;
    width: 100%;
    height: auto;
    aspect-ratio: var(--aspect, 0.66667);
}

.BigScreen .swiper-carousel-animate-opacity {
  aspect-ratio: var(--aspect, 1.778);
}

.swiper-carousel img  {
    position: relative;         /* <-- gör alla lager absolut positionerade */
    inset:0;                    /* <-- fyll hela ytan, exakt samma rundning */
    width:100%;
    height:100%;
    object-fit:cover;
    border-radius:inherit;
  }


.swiper-carousel .slide-content {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 0;
  padding: 16px 16px 16px 16px;
  box-sizing: border-box;
  border-radius: 0 0 0px 0px;
  backdrop-filter: blur(10px);

}



.swiper-carousel {
  --swiper-navigation-color: #000;
  --swiper-pagination-color: #fff;
  --swiper-pagination-bullet-inactive-color: #999;
}


.main__light-mode .swiper-carousel {
  /* ljus bakgrund */
  --swiper-pagination-color: #000; /* aktiva bullets */
  --swiper-pagination-bullet-inactive-color: #000; /* inaktiva bullets */
}



.main__light-mode .swiper-carousel .swiper-pagination-bullet-active {
    --swiper-pagination-color: #000; /* aktiva bullets */
}

.aC_Ljus .swiper-carousel {
  --swiper-navigation-color: #fff;
}



.teaser__vignette {
  color: var(--ds-theme-color);
  display: block;
  font-family: var(--ds-font--sans);
  font-size: .75rem;
  font-size: clamp(12px,.75rem,24px);
  font-variation-settings: "opsz" 12;
  font-weight: 700;
  letter-spacing: .03125rem;
  line-height: 1.1;
  margin-bottom: 4px;
  text-transform: uppercase;
}



.teaser__title {
  font-family: var(--ds-font--serif);
  font-size: 1.375rem;
  font-size: clamp(22px,1.375rem,40px);
  font-variation-settings: "opsz" 22;
  font-weight: 500;
  letter-spacing: normal;
  line-height: 1.3;
}

.swiper-carousel .slide-content.nograd {
    background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0));
}


    .showArrow { 
    --swiper-navigation-sides-offset: 40px;
    }


@media (max-width: 640px) {

    .showArrow { 
    --swiper-navigation-size: 25px; 
    --swiper-navigation-sides-offset: 25px;
    }


  .showArrow .swiper-carousel .swiper-button-next,
  .showArrow  .swiper-carousel .swiper-button-prev {
    display: block !important; 
  }
}

</style>

<div bind:this={container} class="swiper swiper-carousel">
  <div class="swiper-wrapper">

    {#each slides as [image, rubrik, ingress, link, textfarg, bg_farg, bg_opacitet, gradient, txtstrl_stor, txtstrl_liten]}
      <div class={`swiper-slide`} style={`max-width:${maxWidthSelected};`}>
        <div class="swiper-carousel-border-background" style={`border:${frameCss}; border-radius:${borderRadius}px`}>
        <div class="swiper-carousel-animate-opacity">
        <a href={link} target="_blank"  rel="noopener noreferrer"   
        class= "picLink"
        class:noLink={!link || link === "#"}>    
            <img src={image} alt={ingress} />
            <div class={`slide-content ${gradient === "1" ? '' : 'nograd'} `} style={`color:${textfarg}; background-color:${hexToRgba(bg_farg, bg_opacitet)}; font-size:2.5rem; backdrop-filter: ${backdropFilter === "blur(0px)" ? 'none' : backdropFilter}; -webkit-backdrop-filter: ${backdropFilter === "blur(0px)" ? 'none' : backdropFilter};`}>
              <div class="teaser__vignette" style={`color:${textfarg}; font-size:${withUnit(txtstrl_liten)};`}>{ingress}</div>  
              <div class="teaser__title" style={`color:${textfarg}; font-size:${withUnit(txtstrl_stor)};`}>{rubrik}</div>
            </div>
        </a>    
        </div>
        </div>
      </div>
    {/each}


</div>

  <div class="swiper-button-prev"></div>
  <div class="swiper-button-next"></div>
  <div class="swiper-pagination"></div>


</div>